import React, { useState, useEffect } from "react";
import axios from "axios";
import { ApiUrl } from "../../components/API/Api";
import { CircularProgress } from "@mui/material";
import { useLocation } from "react-router-dom";

const Instituation = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [id, setPageTitle] = useState("");
  let location = useLocation();
  const url = location.pathname;

  useEffect(() => {
    const path = {
      "/jias": 31,
      "/special-ministries": 32,
      "/schools": 33,
      "/primaryschool": 34,
      "/middle-tamil": 35,
      "/high-tamil": 36,
      "/high-sec-tamil": 37,
      "/matric-sec-school": 38,
      "/nursery-primary-schools": 39,
      "/cbse-schools": 40,
      "/religious-primary-school": 41,
      "/religious-middle-tamil": 42,
      "/religious-high-tamil": 43,
      "/religious-high-sec-school-tamil": 44,
      "/religious-mat-high-school": 45,
      "/religious-nursery-primary": 46,
      "/religious-cbse-school": 47,
      "/colleges": 48,
      "/college-diocesan": 49,
      "/religious-colleges": 50,
      "/institute-poly-diocesan": 51,
      "/institute-poly-religious": 52,
      "/st-joseph-minor-seminary": 53,
      "/seminarian-institution": 54,
      "/seminarians-fund": 55,
      "/home-diocesan": 56,
      "/home-religious": 57,
      "/old-age-diocesan": 58,
      "/old-age-religious": 59,
      "/obituary": 60,
    };
    setPageTitle(path[url] ? path[url] : url);
  }, [url]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const olddata = localStorage.getItem("Pages");
        const response = await axios.get(`${ApiUrl}/get/Pages`);
        const newData = response?.data?.data;
        if (olddata === newData) {
          setData(JSON.parse(olddata))
        }else{
          localStorage.removeItem("Pages");
          localStorage.setItem("Pages", JSON.stringify(newData));
          setData(newData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <CircularProgress
        sx={{ display: "block", margin: "auto", marginTop: "2rem" }}
      />
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="text-center mt-5">
        <b>No Data Available</b>
      </div>
    );
  }

  const filteredData = data.filter((item) => item.id === id);

  if (filteredData.length === 0) {
    return (
      <div className="text-center mt-5">
        <b>Under Construction</b>
      </div>
    );
  }

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            {filteredData.map((item) => (
              <div key={item.id}>
                <h2 className="heading">{item.title}</h2>
                <div
                  style={{ textAlign: "justify" }}
                  dangerouslySetInnerHTML={{
                    __html: `${item.content}`,
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Instituation;
